import { useRef, useState } from 'react';

export default function useSlider(initialSlide = 0) {
  const swiperRef = useRef();
  const [activeIndex, setActiveIndex] = useState(initialSlide);

  const slideTo = (index) => swiperRef.current.slideTo(index);

  const slideToLoop = (index) => swiperRef.current.slideToLoop(index);

  const slidePrev = () => swiperRef.current.slidePrev();

  const slideNext = () => swiperRef.current.slideNext();

  return [
    {
      onSlideChangeTransitionStart: ({ realIndex }) =>
        setActiveIndex(realIndex),
      onBeforeInit: (swiper) => {
        swiperRef.current = swiper;
      },
      initialSlide,
    },
    {
      slideTo,
      slideToLoop,
      slidePrev,
      slideNext,
    },
    {
      activeIndex,
    },
  ];
}
